import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"

const Miniwidget = props => {
  const itemCount = props.reports.length;
  // Dynamic grid: if 5 items, use 5 cols; if 4 items, use 3 cols (xl-3 means 4 items per row); if X items, etc.
  // Using row-cols-{count} is the cleanest way to force them on the same line.
  const rowColsClass = `row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-xl-${itemCount}`;

  return (
    <React.Fragment>
      <Row className={`${rowColsClass} align-items-stretch`}>
        {props.reports.map((report, key) => (
          <Col key={key} className="mb-4 d-flex">
            <Card className="mini-stat bg-primary h-100 w-100">
              <CardBody className="card-body mini-stat-img d-flex flex-column">
                <div className="mini-stat-icon">
                  <i className={"float-end mdi mdi-" + report.iconClass}></i>
                </div>
                <div className="text-white flex-grow-1">
                  <h6 className="text-uppercase mb-2 font-size-13 text-white">{report.title}</h6>
                  <h3 className="mb-3 text-white">{report.total}</h3>
                </div>
                <div>
                  {report.average && (
                    <React.Fragment>
                      <span className={"badge bg-" + report.badgecolor}> {report.average} </span>
                      <span className="ms-2 text-white-50 font-size-12">{report.desc || "Vs période précédente"}</span>
                    </React.Fragment>
                  )}
                </div>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
    </React.Fragment>
  )

}

export default Miniwidget
